




























































































import Vue, { PropOptions } from 'vue';
import * as TypeVariable from '@/parts/VariableInput.vue';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';
import mv from './mixins-views2';
import InfiniteLoading from 'vue-infinite-loading';

export default Vue.extend({
  name: 'Annkenn',
  mixins: [mv],
  components: { InfiniteLoading},
  props: {
    myData: Object as PropOptions<Models.ICoordinator>,
    getDatas: Object as PropOptions<Models.IGetDatas>,
  },
  computed: {},
  data() {
    return {
      inputData: new Models.CAnnkenn(),
      tmpRejects: [] as number[],
      inputRejects: [] as number[],
      rejectModal: false,
      items: [
        {key: 'subject', name: '件名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 100},
        {key: 'responsibleID', name: '担当者', type: TypeVariable.INPUT_TYPE.SELECT, required: false, error: '', options: PClass.CONST.ARRAY.NORMAL, class: 'flat'},
        {key: 'introduction', name: '本文', type: TypeVariable.INPUT_TYPE.TEXTAREA, required: true, error: '', max: 1500},
      ] as TypeVariable.IVariableInput[],
      thDatas: [
        {key: 'subject', name: '件名', class: 'subject', sort: true},
        {key: 'responsibleName', name: '担当者', sort: true},
        {key: 'introduction', name: '本文'},
        {key: 'createDate', name: '作成日', sort: true},
        {key: 'updateDate', name: '更新日', sort: true},
      ] as TypeVariable.IVariableInput[],
      localData: {} as Models.ILocalData,
      listDispModal: false,
      infiniteId: 0,
      ngSearchWord: '',
      localKey: 'annkenn',
    };
  },
  async mounted() {
    // ローカルデータ初期化
    this.localData = new Models.CLocalData('subject', this.thDatas);
    (this as any).mixSetLocalData(this.localKey);
    // データ読み込み
    await (this as any).fncGetDatas(true);
  },
  methods: {
    async onClickEditMode(editData: Models.IAnnkenn) {
      this.$emit('loading', true);
      this.inputData = editData;
      // this.inputData = JSON.parse(JSON.stringify(this.getDatas.filter((v) => (v.id === editData.id))[0]));
      await this.getReject(editData.id);
      (this as any).mixChangeMode(PClass.CONST.MODE.EDIT);
      scrollTo(0, 0);
      this.$emit('loading', false);
    },
    onClickNewMode() {
      this.inputData = new Models.CAnnkenn();
      (this as any).mixChangeMode(PClass.CONST.MODE.NEW);
    },
    onClickCancel() {
      // データクリア
      this.inputData = new Models.CAnnkenn();
      this.tmpRejects = [];
      this.inputRejects = [];
      (this as any).mixChangeMode(PClass.CONST.MODE.NORMAL);
    },
    async onClickUpdate() {
      this.$emit('loading', true);
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        this.$emit('loading', false);
        return false;
      }
      // console.log(this.inputData);
      const api = new PClass.API();
      const res = await api.post<Models.IAnnkenn, {id: number}>(`annkenn/${(this as any).mixGetMode() === PClass.CONST.MODE.NEW ? 'new' : 'edit'}`, this.inputData);
      // console.log(res);

      if (!res.result.error) {
        // 個別の拒絶設定を反映
        let rRes;
        const targetID = res.data.id;
        // console.log(targetID);
        if (this.tmpRejects.length > 0) {
          const sendRejects = this.inputRejects.map((v) => ({annkennID: targetID, clientID: v} as Models.IAnnkennReject))
          rRes = await api.post<Models.IAnnkennReject[], any>('annkenn_reject/', sendRejects);
        } else {
          rRes = await api.delete<any>('annkenn_reject/', {id: targetID});
        }
        await (this as any).fncGetDatas(true);
        this.onClickCancel()

        if (rRes.result.error) {
          this.$emit('info', '個別NG設定に失敗しました。');
        }
      } else {
        this.$emit('info', res.result.message);
      }
      this.$emit('loading', false);
    },
    onClickCloseRejectModal() {
      this.rejectModal = false;
    },
    async getReject(id: number) {
      const api = new PClass.API();
      const res = await api.get<Models.VAnnkennReject>('annkenn_reject', {id});
      if (!res.result.error) {
        const ids = res.data.annkennReject.map((v) => (v.clientID));
        this.inputRejects = ids;
        this.tmpRejects = ids.concat();
      }
    },
    onClickSetReject() {
      this.inputRejects = this.tmpRejects.concat();
      this.rejectModal = false;
    },
    async onClickDelete(deleteData: Models.IAnnkenn) {
      await (this as any).mixDeleteAction('この案件を削除します。\nよろしいでしょうか？', deleteData)
    },
    async infiniteHandler($state: any) {
      await (this as any).mixInfiniteHandler($state)
    },
  },
});

